import { Button } from "antd";
import React from "react";
import { getColor } from "../util/CC";

export default function CustomButton(props) {

    const template = window.sitesettings.template_info;
    const { content = {} } = props;

    const {
        location = "main",
        component = "blank_space",
        container = true,
        data = {}
    } = content;

    const {
        label = "Button",
        link = "",
        type = 0,
        tab = true,
        align = "center",
        padding_x = 0,
        padding_y = 0,
        button_block = false,
        background_colour = 0,
    } = data;

    const linkOut = () => {

        if (link.includes("anchor:")) {
            let _f = props?.items.find(item => item.id === link.replace("anchor:", ""));
            if (_f) {
                let el = document.getElementById(_f.id);
                let parent = document.getElementById("main-content");
                let search = document.getElementById("search_bg");
                let search_bar_height = search?.offsetHeight || 110;
                if (el && parent) {
                    window.scrollTo({
                        top: el.offsetTop - search_bar_height,
                        behavior: "smooth"
                    });
                }
            }
            return; 
        }

        if (link) {
            window.open(link, (tab) ? "_blank" : "_self");
        }
    }

    const drawRender = () => {

        let _style = {
            display : "block",
            textAlign : align,
            padding : padding_y + "px " + padding_x + "px",
            background: getColor(background_colour, template)
        }

        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={_style}>
                <Button aria-label={(tab) ? "Visit link (opens in a new tab)" : "Visit link"} block={button_block} onClick={() => linkOut()} className={"bm-btn-" + type} >{label}</Button>
                </div>
            </div>
        )

    }

    return drawRender();
}